import * as Twilio from 'twilio-video'

export enum VideoTrackType {
  PLAYBACK = 'PLAYBACK',
  SCREENSHARE = 'SCREENSHARE',
  WEBCAM = 'WEBCAM',
}

export interface VideoState {
  playable: boolean
  playing: boolean
  quality: string
  refSet: boolean
  isSubscribed: boolean
}

export interface VideoProps {
  publication: Twilio.LocalVideoTrackPublication | Twilio.RemoteVideoTrackPublication
  trackSid: string
  isHidden?: boolean
  mirrorVideo?: boolean
  trackType?: VideoTrackType
  height?: number
  width?: number
}
